enum Mutations {
  SET_DATA_QUERY = 'setDataQuery',
  SET_EVENTS_QUERY_REQUEST_UID = 'setEventsQueryRequestUid',
  SET_LOAD_STATE = 'setLoadState',
  SET_REQUEST_PARAMS = 'setRequestParams',
  SET_DATA_QUERY_REQUEST_UID = 'setDataQueryRequestUid'
}

export default Mutations;
